
(function(open) {
        XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
            this.addEventListener("load", function() {
                // Run the function after every AJAX request completes
                 replace_color_text();
            });
            open.call(this, method, url, async, user, password);
        };
    })(XMLHttpRequest.prototype.open);


document.addEventListener("DOMContentLoaded", function() { 
  replace_color_text();

  
  }); 

function replace_color_text(){
  //console.log("pranav2");
 // setTimeout(function() {
      //  console.log("pranav1");
        var buttons = document.querySelectorAll('.gf-option-75470 .gf-option-box button');


       // var gfLabels1 = document.querySelectorAll('.gf-option-label .gf-label');

       //  gfLabels.forEach(function(gfLabel1) {
       //      var labelText1 = gfLabel.textContent.trim();
       //      var text_data1 = labelText.substring(0, labelText.indexOf('(')).trim();
       //  }


       var gfLabels1 = document.querySelectorAll('.selected-item.gf-option-label a[data-fid="75470"] .gf-label');

        gfLabels1.forEach(function(gfLabel1) {
            var labelText1 = gfLabel1.textContent.trim();
          
           // var text_data1 = labelText1.substring(0, labelText1.indexOf('(')).trim();

            var text_data1 = labelText1.indexOf('(') !== -1 ? labelText1.substring(0, labelText1.indexOf('(')).trim() : labelText1.trim();

            // Update the text content of .gf-label
            gfLabel1.textContent = text_data1;
          });
          
          

        buttons.forEach(function(button) {
            var gfLabel = button.querySelector('.gf-label');
            
            var labelText = gfLabel.textContent.trim();

            // Extract the image filename from labelText
          
           // var text_data = labelText.substring(0, labelText.indexOf('(')).trim();

          var text_data = labelText.indexOf('(') !== -1 ? labelText.substring(0, labelText.indexOf('(')).trim() : labelText.trim();
            
          console.log('text_data',text_data);

            // Construct the full image URL
           // var img_data = 'https://cdn.shopify.com/s/files/1/0740/0390/6857/files/' + imgSrc.trim();

            // Create img element with src and alt attributes
           // var imgElement = document.createElement('img');
          


            // Replace gf-label content with image element
            gfLabel.innerHTML = '<span>'+text_data+'</span>'; // Clear existing content

              // Update the button's data-fvalue and title attributes
   //button.setAttribute('data-fvalue', text_data);
    button.setAttribute('title', text_data);
          
            // gfLabel.appendChild(imgElement); // Append image element
        });
        
        
  //  }, 500);
}



window.onload = function() {

   


// Find all elements with the class name "privay_policy"
const elementsWithPrivacyPolicy = document.getElementsByClassName("privay_policy");

// Loop through the elements and remove the "privay_policy" class from each of them
for (let i = 0; i < elementsWithPrivacyPolicy.length; i++) {
  elementsWithPrivacyPolicy[i].classList.remove("privay_policy");
}

    // JavaScript to remove the <span class="breadcrumb__link"><a href="/collections">Collections</a></span> element
  // const collectionsLink = document.querySelector('.breadcrumb__link a[href="/collections"]');

  // if (collectionsLink) {
  //   collectionsLink.parentElement.remove();
  // }

    // JavaScript to remove both elements
  // const separator = document.querySelector('.breadcrumb__separator');
  // const collectionsLink = document.querySelector('.breadcrumb__link a[href="/collections"]');

  // if (separator) {
  //   separator.remove();
  // }

  // if (collectionsLink) {
  //   collectionsLink.parentElement.remove();
  // }
  


 
 // var customerLogin = document.getElementsByClassName("image_block");
  //if (customerLogin) {
 //   customerLogin.style.display = "none";
 // }

  
};